import { Language } from '@barracuda/shared';
import { useCallback } from 'react';

enum oneTrustGroups {
  PERFORMANCE_COOKIES = 'C0002'
}

export const useOneTrust = () => {
  const hasActiveOneTrustGroup = useCallback(
    (group: oneTrustGroups): boolean =>
      !!window.OneTrust?.IsAlertBoxClosed?.() && !!window?.OnetrustActiveGroups?.includes(group),
    []
  );

  // OT is basing on HTML lang attribute, it has to be exactly as valid OT lang code
  const mapOTLangCode = (lang: Language) => {
    if (lang === 'JPN') return 'JA';

    return 'EN'; // default language fallback
  };

  const reloadOTBanner = () => {
    const otInitialized = document.getElementById('onetrust-consent-sdk') instanceof HTMLElement;
    if (otInitialized && !window.OneTrust?.IsAlertBoxClosed?.()) {
      window.location.reload();
    }
  };

  return {
    oneTrustGroups,
    hasActiveOneTrustGroup,
    mapOTLangCode,
    reloadOTBanner,
    toggleConsentModal: window.OneTrust?.ToggleInfoDisplay
  };
};
